export const giftcardConfig = {
  panels: [
    {
      id: 1,
      title: 'Box Ricette',
      img: 'https://api.quomi.it/oldimg/Polpette-di-pollo-con-friggitelli-thumb-small.jpg',
      panelTitle: 'Gift card box ricette',
      panelDescription: 'La gift card perfetta per far divertire tutti ai fornelli! Personalizza il tuo regalo: scegli il numero di ricette e di persone. <b>La spedizione è sempre inclusa nel prezzo</b>.',
      defaultPrice: [
        {
          value: 2,
          price: [
            {
              people: 2,
              total: 34.90
            },
            {
              people: 4,
              total: 49.90
            },
            {
              people: 6,
              total: 65.90
            },
            {
              people: 8,
              total: 81.90
            },
          ]
        },
        {
          value: 3,
          price: [
            {
              people: 2,
              total: 41.90
            },
            {
              people: 4,
              total: 65.90
            },
            {
              people: 6,
              total: 88.90
            },
            {
              people: 8,
              total: 112.90
            },
          ]
        },
        {
          value: 4,
          price: [
            {
              people: 2,
              total: 49.90
            },
            {
              people: 4,
              total: 81.90
            },
            {
              people: 6,
              total: 112.90
            },
            {
              people: 8,
              total: 148.30
            },
          ]
        }
      ],
      cardName: 'Box',
      giftImage: 'https://api.quomi.it/oldimg/box-ricette-gift-card-quomi.webp',
      discount: 0
    },{ 
      id: 2,
      title: 'Cassette frutta e verdura',
      img: 'https://api.quomi.it/oldimg/cass4.webp',
      panelTitle: 'Gift card cassette frutta e verdura ',
      panelDescription: 'Regala una cassetta di frutta e verdura fresca e di stagione. Perfetta per tutte le occasioni. <b>La spedizione è sempre inclusa nel prezzo</b>.',
      prices: [
        {
          value: 0,
          price: 25.80
        },
        {
          value: 1,
          price: 25.80
        },
        {
          value: 2,
          price: 25.80
        },
        {
          value: 3,
          price: 25.80
        }
      ],
      products: [
        {
          id: 0,
          extraId: 4973
        },
        {
          id: 1,
          extraId: 3217
        },
        {
          id: 2,
          extraId: 3219
        },
        {
          id: 3,
          extraId: 4137
        }
      ]
    },
    {
      id: 3,
      title: 'Kit Aperitivo',
      img: 'https://api.quomi.it/oldimg/ape2.webp',
      panelTitle: 'Gift card kit aperitivo',
      panelDescription: 'Qualcuno ha detto aperitivo? Regala il kit completo per realizzare dei cocktail da vero barman, firmati Martini. <b>La spedizione è sempre inclusa nel prezzo</b>.',
      prices: [
        {
          value: 0,
          price: 40.80
        },
        {
          value: 1,
          price: 50.80
        },
        {
          value: 2,
          price: 35.80
        },
        {
          value: 3,
          price: 70.80
        }
      ],
      products: [
        {
          id: 0,
          extraId: 3445
        },
        {
          id: 1,
          extraId: 3097
        },
        {
          id: 2,
          extraId: 3932
        },
        {
          id: 3,
          extraId: 3722
        }
      ],
      discount: 0
    },
    {
      id: 5,
      title: 'A valore',
      img: 'https://api.quomi.it/oldimg/dispensa.webp',
      panelTitle: 'Gift card a valore',
      panelDescription: 'Se vuoi lasciare libertà di scelta, questa è la soluzione ideale. Scegli l’importo da regalare, potranno usarlo su ricette e bottega.',
      prices: [
        {
          value: 0,
          price: 25
        },
        {
          value: 1,
          price: 50
        },
        {
          value: 2,
          price: 100
        },
        {
          value: 3,
          price: 200
        }
      ],
      cardName: 'Importo gift card',
      giftImage: 'https://api.quomi.it/oldimg/gift_card_quomi.png',
      discount: 0
    }
  ],
  defaultPrice: 0

}